import {useHeaderHeight} from '@react-navigation/elements';
import type {StackScreenProps} from '@react-navigation/stack';
import {observer} from 'mobx-react-lite';

import type {RootStackParamList} from '../../RootStack/RootStackParamList';
import ShowInsightScreen from '../../screens/ShowInsightScreen';
import fallbackQuote from '../../StaticMaterials/fallbackQuote';
import fallbackTopic from '../../StaticMaterials/fallbackTopic';
import useInsight from './useInsight';

export type ShowInsightBindingProps = StackScreenProps<
  RootStackParamList,
  'ShowInsight'
>;

export default observer(function ShowInsightBinding(
  props: ShowInsightBindingProps,
) {
  const {route} = props;
  const {quoteId: _quoteId, topicId: _topicId} = route.params ?? {};
  const quoteId = parseInt(_quoteId ?? '', 10);
  const topicId = parseInt(_topicId ?? '', 10);

  const {topic, quote} = useInsight(topicId, quoteId);

  const headerHeight = useHeaderHeight();

  return (
    <ShowInsightScreen
      today={null}
      quoteBody={stubText(quote && quote.body, fallbackQuote.body)}
      quoteSource={stubText(quote && quote.source, fallbackQuote.source)}
      topicBody={stubText(topic && topic.body, fallbackTopic.body)}
      compensateHeaderHeight={headerHeight}
    />
  );
});

function stubText(_: string | null | undefined, stub: string) {
  if (_ === undefined) {
    return 'Загрузка...';
  }
  return _ ?? stub;
}
